module.exports = {
  APPID: "100000",
  APP_TITLE: "CoolDrama H5",
  APP_DESC: "Create CoolDrama H5 Sample",
  showSearch: true,
  USER_ICON_URL: "https://statictxeo.tikshortsbox.com/tiktok-minis-img/cooldrama-logo.png",
  HOME_LOGO_URL: "https://statictxeo.tikshortsbox.com/tiktok-minis-img/cooldrama-homelogo.png",
  CLASS_NAME_EXTENSION: "cd",
  // 主题色：未写的项使用 themeDefaults.js 默认值
  THEME: {
    tabActiveColor: "#E53361",
    brandGradientStart: "#EC008C",
    brandGradientEnd: "#FC4037",
    mineVipRightGradientStart: "#EC008C",
    mineVipRightGradientEnd: "#FC4037",
    episodeActiveColor: "#FE375F",
    payGradientStart: "#EF0880",
    payGradientEnd: "#FA3840",
    modalBtnGradientStart: "#FC3F3A",
    modalBtnGradientEnd: "#ED018A",
    discountGradientStart: "#FF482B",
    discountGradientEnd: "#FF9D5E",
  },
};
